import { useAnalytics } from '@/composables/analytics'
import { createThrottler } from '@/lib/helpers'
import { useLogger } from '@booksy-com/vue-tools'

const { dispatch, EVENTS } = useAnalytics()
const pageViewThrottler = createThrottler(500)
const logger = useLogger('router.guard.track-page')

export default function (to, from, next) {
  logger.debug(to.path)

  pageViewThrottler(() => {
    dispatch(EVENTS.PAGE_VIEW, { from, to })
  })

  next()
}
